import { createI18n } from "vue-i18n";
import { getCurrentEnv } from "@/utils/util";
import cn from "./cn.json";
import en from "./en.json";
import tw from "./tw.json";

const getCurrentLanguage = () => {
  let matched: string = "cn";
  const languages = ['cn', 'en', 'tw'];
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get("lang") as string;
  languages.forEach((language) => {
    if (lang === language) {
      matched = language;
    }
  });
  return matched;
}
const envMode: any = getCurrentEnv();
const lang = getCurrentLanguage();
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: lang,
  fallbackLocale: "cn",
  silentTranslationWarn: (envMode === "production"),
  messages: { cn, en, tw },
});

export default i18n;
